<template>
    <div class="address-index">
        <div class="flex align-center header" v-link="'/Address/Edit/0'">
            <span class="jcicon jcicon-jiahao1 fs_34 c_main"></span>
            <span class="fs_30 c_1a">&ensp;新增收货地址</span>
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in list" :key="index" @click="setAddressId(item.id)">
                <div class="item__top">
                    <div>
                        <span class="fs_30 c_1a">{{item.linkman}}</span>
                        <span class="fs_30 c_1a">&emsp;{{item.mobile_phone}}</span>
                    </div>
                    <div class="mt_20">
                        <span class="fs_28 c_80 lh_34">{{item.province}}{{item.city}}{{item.area}}{{item.address}}</span>
                    </div>
                </div>
                <div class="flex__between__center item__bottom">
                    <div v-if="item.is_default==1" @click.stop="setDefault(item.id)">
                        <span class="jcicon jcicon-unselected fs_34 c_98"></span>
                        <span class="fs_26 c_98">&nbsp;设为默认</span>
                    </div>
                    <div v-else>
                        <span class="jcicon jcicon-dui fs_34 c_main"></span>
                        <span class="fs_26 c_1a">&nbsp;默认地址</span>
                    </div>
                    <div class="flex__between__center">
                        <div v-link="'/Address/Edit/'+item.id">
                            <span class="jcicon jcicon-bianji fs_34 c_98"></span>
                            <span class="fs_26 c_98">&nbsp;编辑</span>
                        </div>
                        <div class="ml_50" @click.stop="del(item.id)">
                            <span class="jcicon jcicon-shanchu1 fs_34 c_98"></span>
                            <span class="fs_26 c_98">&nbsp;删除</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"AddressIndex",
    data(){
        return{
            list:[]
        }
    },
    methods:{
        // 数据
        load(){
            this.axios.post('/wechat.php/Address/getMyAddress',{
                user_id: localStorage.user_id
            }).then(
                res=>{
                    if(res.data.code==1||res.data.code==102){
                        this.list=res.data.data;
                    }
                }
            )
        },
        // 设置默认
        setDefault(id){
            this.axios.post('/wechat.php/Address/changeDefault',{
                user_id: localStorage.user_id,
                id: id
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.$toast(res.data.message);
                        this.load();
                    }
                }
            ) 
        },
        // 删除
        del(id){
            this.$dialog.confirm({
                message: '确定删除该地址？'
            }).then(() => {
                this.axios.post('/wechat.php/Address/deleteAddress',{
                    user_id: localStorage.user_id,
                    id: id
                }).then(
                    res=>{
                        if(res.data.code==1){
                            this.load();
                        }
                    }
                ) 
            })
        },
        // 选择地址
        setAddressId(data){
            this.$store.commit('setAddressId',data);
            this.$router.go(-1);
        }
    },
    mounted(){
        this.load();
    }
}
</script>
<style scoped>
.header{
    height: 100px;
    padding: 0 30px;
    margin-top: 15px;
    background: #fff;
}
.item{
    padding: 0 30px;
    margin-top: 15px;
    background: #fff;
}
.item__top{
    padding: 30px 0; 
    border-bottom: 2px solid #e6e6e6;
}
.item__bottom{
    height: 100px;
}
</style>




// WEBPACK FOOTER //
// src/pages/address/Index.vue